import React from "react";

/**
 * The `--- photolevs ---` device, used for loading states and the brand mark.
 */
export default function Wordmark({ size = 13, ink = false, text = "photolevs" }) {
  return (
    <span
      className={`wordmark${ink ? " wordmark--ink" : ""}`}
      style={{ fontSize: size }}
      aria-label={text}
    >
      <span className="rule" aria-hidden="true" />
      {text}
      <span className="rule" aria-hidden="true" />
    </span>
  );
}